export default {
  name: 'needs-child-item',
  props: {
    position: Number,
    needItem: Object
  }
}